import { render, staticRenderFns } from "./TransferApproval.vue?vue&type=template&id=f8d59de4&"
import script from "./TransferApproval.vue?vue&type=script&lang=js&"
export * from "./TransferApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports